import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { MetodosgenService } from 'src/app/services/metodosgen.service';
import { JavapiService } from 'src/app/services/javapi.service';

@Component({
  selector: 'app-comentarios',
  templateUrl: './comentarios.component.html',
  styleUrls: ['./comentarios.component.scss'],
  standalone: false
})
export class ComentariosComponent implements OnInit {

  @Input() modulo!: string;
  @Input() referencia_id!: number;
  @Input() titulo_referencia: string = '';

  @ViewChild(IonContent, { static: false }) content!: IonContent;

  comentarios: any[] = [];
  nuevoComentario: string = '';
  isLoading: boolean = false;
  isSending: boolean = false;
  usuarioActual: string = '';

  constructor(
    private modalCtrl: ModalController,
    private metodosGenService: MetodosgenService,
    private javapiService: JavapiService
  ) { }

  ngOnInit() {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      const user = JSON.parse(userJson);
      this.usuarioActual = user.l_usuario || '';
    }
    this.cargarComentarios();
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async cargarComentarios() {
    this.isLoading = true;
    try {
      const payload = this.metodosGenService.setModeloGeneral(
        "genModel", "getComentarios",
        this.modulo,
        String(this.referencia_id),
        '', '', '', '', '', '', '', '', '', '', '', '', ''
      );

      const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (res && res.length > 0) {
        if ((res[0] as any).Error) {
          this.comentarios = [];
        } else {
          // Flip array to show oldest first, newest at the bottom naturally
          this.comentarios = res.reverse();
          this.scrollToBottom();
        }
      } else {
        this.comentarios = [];
      }
    } catch (e) {
      console.error('Error loading comentarios', e);
      this.comentarios = [];
    } finally {
      this.isLoading = false;
    }
  }

  async enviarComentario() {
    if (!this.nuevoComentario || this.nuevoComentario.trim() === '') return;

    this.isSending = true;
    try {
      const payload = this.metodosGenService.setModeloGeneral(
        "genUpdate", "addComentario",
        this.modulo,
        String(this.referencia_id),
        this.nuevoComentario.trim(),
        this.usuarioActual,
        '', '', '', '', '', '', '', '', '', '', ''
      );

      const res: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      if (res) {
        this.nuevoComentario = '';
        await this.cargarComentarios();
      }
    } catch (e) {
      console.error('Error adding comentario', e);
    } finally {
      this.isSending = false;
    }
  }

  // Scroll logic for chat feeling
  scrollToBottom() {
    setTimeout(() => {
      if (this.content) {
        this.content.scrollToBottom(300);
      }
    }, 200);
  }

}
